export const ROLE_HEADER = 'x-role';
export const DEFAULT_SETTINGS = { theme: 'light', grids: {} };
//# sourceMappingURL=api.js.map